<div class="bowling-setup">
  <div class="setup-header">
    <button class="back-btn" (click)="goBack()">
      <span class="back-arrow">&#8592;</span>
    </button>
    <span class="setup-title">{{ currLang === 'ar' ? 'إعداد البولينج' : 'Bowling Setup' }}</span>
    <button class="randomize-btn" (click)="randomize()">
      {{ currLang === 'ar' ? 'عشوائي' : 'Randomize' }}
    </button>
  </div>

  <div class="mode-toggle">
    <button
      class="mode-card"
      [class.active]="mode === BowlingMode.ONE_VS_ONE"
      (click)="setMode(BowlingMode.ONE_VS_ONE)">
      <span class="mode-icon">🎳</span>
      <span class="mode-title">{{ currLang === 'ar' ? 'فرد ضد فرد' : '1 vs 1' }}</span>
      <span class="mode-sub">{{ currLang === 'ar' ? 'لاعب واحد لكل جانب' : 'One player per side' }}</span>
    </button>
    <button
      class="mode-card"
      [class.active]="mode === BowlingMode.TEAM_VS_TEAM"
      (click)="setMode(BowlingMode.TEAM_VS_TEAM)">
      <span class="mode-icon">👥</span>
      <span class="mode-title">{{ currLang === 'ar' ? 'فريق ضد فريق' : 'Team vs Team' }}</span>
      <span class="mode-sub">{{ currLang === 'ar' ? 'يتناوب اللاعبون مثل الواقع' : 'Players rotate each frame' }}</span>
    </button>
  </div>

  <div class="setup-body">
    <div class="team-panel team-a">
      <div class="team-color-bar"></div>
      <div class="team-name-input" *ngIf="mode === BowlingMode.TEAM_VS_TEAM">
        <input type="text"
               [value]="sideANameInput"
               (input)="onSideANameChange($any($event.target).value)"
               [placeholder]="currLang === 'ar' ? 'اسم الفريق' : 'Team name'"
               maxlength="20" />
      </div>
      <div class="side-label-1v1" *ngIf="mode === BowlingMode.ONE_VS_ONE">
        {{ sideALabel }}
      </div>
      <div class="team-count">
        {{ sideAStudents.length | arabicNumber:currLang }}
        {{ currLang === 'ar' ? (mode === BowlingMode.ONE_VS_ONE ? 'لاعب' : 'طالب') : (mode === BowlingMode.ONE_VS_ONE ? 'player' : 'students') }}
      </div>
      <div class="team-drop-zone"
           cdkDropList
           id="bowling-side-a"
           [cdkDropListData]="sideAStudents"
           [cdkDropListConnectedTo]="['bowling-pool', 'bowling-side-b']"
           (cdkDropListDropped)="drop($event)">
        <div class="drop-placeholder" *ngIf="sideAStudents.length === 0">
          {{ currLang === 'ar' ? 'اسحب الطلاب هنا' : 'Drag students here' }}
        </div>
        <div class="student-chip" *ngFor="let student of sideAStudents" cdkDrag>
          <div class="drag-preview" *cdkDragPreview>
            <app-student-avatar [student]="student" [size]="36"></app-student-avatar>
            <span>{{ getStudentName(student) }}</span>
          </div>
          <app-student-avatar [student]="student" [size]="32"></app-student-avatar>
          <span class="student-name">{{ getStudentName(student) }}</span>
        </div>
      </div>
    </div>

    <div class="student-pool-panel">
      <div class="pool-title">{{ currLang === 'ar' ? 'الطلاب' : 'Students' }}</div>
      <div class="pool-count">{{ availableStudents.length | arabicNumber:currLang }} {{ currLang === 'ar' ? 'متاح' : 'available' }}</div>
      <div class="student-pool"
           cdkDropList
           id="bowling-pool"
           [cdkDropListData]="availableStudents"
           [cdkDropListConnectedTo]="['bowling-side-a', 'bowling-side-b']"
           (cdkDropListDropped)="drop($event)">
        <div class="pool-empty" *ngIf="availableStudents.length === 0">
          {{ currLang === 'ar' ? 'تم توزيع جميع الطلاب' : 'All students assigned' }}
        </div>
        <div class="student-chip pool-chip" *ngFor="let student of availableStudents" cdkDrag>
          <div class="drag-preview" *cdkDragPreview>
            <app-student-avatar [student]="student" [size]="36"></app-student-avatar>
            <span>{{ getStudentName(student) }}</span>
          </div>
          <app-student-avatar [student]="student" [size]="32"></app-student-avatar>
          <span class="student-name">{{ getStudentName(student) }}</span>
        </div>
      </div>
    </div>

    <div class="team-panel team-b">
      <div class="team-color-bar"></div>
      <div class="team-name-input" *ngIf="mode === BowlingMode.TEAM_VS_TEAM">
        <input type="text"
               [value]="sideBNameInput"
               (input)="onSideBNameChange($any($event.target).value)"
               [placeholder]="currLang === 'ar' ? 'اسم الفريق' : 'Team name'"
               maxlength="20" />
      </div>
      <div class="side-label-1v1" *ngIf="mode === BowlingMode.ONE_VS_ONE">
        {{ sideBLabel }}
      </div>
      <div class="team-count">
        {{ sideBStudents.length | arabicNumber:currLang }}
        {{ currLang === 'ar' ? (mode === BowlingMode.ONE_VS_ONE ? 'لاعب' : 'طالب') : (mode === BowlingMode.ONE_VS_ONE ? 'player' : 'students') }}
      </div>
      <div class="team-drop-zone"
           cdkDropList
           id="bowling-side-b"
           [cdkDropListData]="sideBStudents"
           [cdkDropListConnectedTo]="['bowling-pool', 'bowling-side-a']"
           (cdkDropListDropped)="drop($event)">
        <div class="drop-placeholder" *ngIf="sideBStudents.length === 0">
          {{ currLang === 'ar' ? 'اسحب الطلاب هنا' : 'Drag students here' }}
        </div>
        <div class="student-chip" *ngFor="let student of sideBStudents" cdkDrag>
          <div class="drag-preview" *cdkDragPreview>
            <app-student-avatar [student]="student" [size]="36"></app-student-avatar>
            <span>{{ getStudentName(student) }}</span>
          </div>
          <app-student-avatar [student]="student" [size]="32"></app-student-avatar>
          <span class="student-name">{{ getStudentName(student) }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="setup-footer">
    <button class="finalize-btn" [class.ready]="canFinalize()" [disabled]="!canFinalize()" (click)="start()">
      {{ currLang === 'ar' ? 'ابدأ اللعبة!' : 'Start Game!' }}
    </button>
    <div class="finalize-hint" *ngIf="!canFinalize()">
      <ng-container *ngIf="mode === BowlingMode.ONE_VS_ONE">
        {{ currLang === 'ar' ? 'اختر لاعبًا لكل جانب' : 'Pick one player per side' }}
      </ng-container>
      <ng-container *ngIf="mode === BowlingMode.TEAM_VS_TEAM">
        {{ currLang === 'ar' ? 'أضف طالبًا واحدًا على الأقل لكل فريق' : 'Add at least 1 student to each team' }}
      </ng-container>
    </div>
  </div>
</div>
